module.exports = __webpack_public_path__ + "4f6f4217e519c3e29d162180c2440bb6.svg";